import { Point } from '../../../../shared/src/data/point'
import { BoundingBox as IBoundingBox } from '../../../../shared/src/data/boundingBox'

export class BoundingBox implements IBoundingBox {
  constructor(
    public readonly min: Point,
    public readonly max: Point,
  ) {}

  public get width(): number {
    return this.max.x - this.min.x
  }

  public get height(): number {
    return this.max.y - this.min.y
  }
}
